import Card from '../../components/ui/Card.jsx'
import Icon from '../../components/ui/Icon.jsx'
import { Input } from '../../components/ui/Field.jsx'

/*
 * Shared admin table. Admin list endpoints return the FULL dataset (no
 * pagination), so a client-side filter here still searches ALL data — it is not
 * limited to a page (see the search/filter rule).
 */
export function AdminToolbar({ search, onSearch, placeholder, action }) {
  return (
    <Card style={{ marginBottom: 16, display: 'flex', gap: 12, alignItems: 'center' }}>
      {onSearch && (
        <div style={{ position: 'relative', flex: 1, maxWidth: 360 }}>
          <span style={{ position: 'absolute', left: 13, top: '50%', transform: 'translateY(-50%)', color: 'var(--color-text-muted)' }}><Icon name="search" size={17} /></span>
          <Input value={search} onChange={(e) => onSearch(e.target.value)} placeholder={placeholder} style={{ height: 42, paddingLeft: 38 }} />
        </div>
      )}
      <div style={{ flex: 1 }} />
      {action}
    </Card>
  )
}

export function AdminTable({ columns, rows, renderRow, loading, empty }) {
  return (
    <Card padding={0}>
      {loading ? (
        <div style={{ padding: 40, textAlign: 'center', color: 'var(--color-text-muted)' }}>…</div>
      ) : rows.length === 0 ? (
        <div style={{ padding: 40, textAlign: 'center', color: 'var(--color-text-muted)' }}>{empty}</div>
      ) : (
        <div style={{ overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', minWidth: 720 }}>
            <thead>
              <tr style={{ background: 'var(--color-bg-lilac)' }}>
                {columns.map((c) => (
                  <th key={c.key} style={{ textAlign: c.align || 'left', padding: '12px 18px', fontSize: 11.5, fontWeight: 600, color: 'var(--color-text-muted)', textTransform: 'uppercase', letterSpacing: '.04em', whiteSpace: 'nowrap' }}>{c.label}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {rows.map((r, i) => (
                <tr key={r.id ?? i} style={{ borderTop: '1px solid var(--color-border-row)' }}>{renderRow(r)}</tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </Card>
  )
}

export const Td = ({ children, align, strong, style }) => (
  <td style={{ padding: '12px 18px', textAlign: align || 'left', color: strong ? 'var(--color-ink)' : 'var(--color-text)', fontWeight: strong ? 600 : 400, ...style }}>{children}</td>
)
